import React from 'react';

export const withStyle = newStyle => WrappedComponent => {
    const WithStyle = ({ oldStyle, ...passThroughProps }) => { return <WrappedComponent style={{ ...oldStyle, ...newStyle }} {...passThroughProps} />; }
    return WithStyle;
}

export default withStyle;